import BaseService from './BaseService';

class TypeAheadService extends BaseService {

  constructor() {
    super({ path: 'type-ahead' });
  }

  search({type, value}) {
    return super.create({
      type,
      value
    }, { ignoreNotifications: true })
  }
}

export default new TypeAheadService();
